import { Avatar, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
export const AvatarItem = ({
  name,
  src,
  showName,
  props,
  fontSize = 'md-medium',
  color = 'secondary-900',
  textTruncate = false,
  maxW = 'auto',
}) => {
  return (
    <Flex gap="4px" alignItems="center">
      <Avatar className="avatar-xs" name={name} src={src} {...props} />
      {showName && (
        <KText
          color={color}
          size={fontSize}
          isTruncated={textTruncate}
          enableTooltip={textTruncate}
          maxW={maxW}
        >
          {name}
        </KText>
      )}
    </Flex>
  );
};
